<loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>

@if (loadingSuccess) {
    @if (results?.length) {
        <div class="flex flex-col gap-2">
            @for (result of results ; track result.startedAt) {
                <import-collection-result-row [result]="result"></import-collection-result-row>
            } 
        </div>
    } @else {
        <div class="bg-slate-100 p-8 rounded shadow text-center text-slate-400 italic text-sm">
            You have not performed any collection imports.
        </div>
    }
}